import { AppJsona } from './Jsona'
import { JsonPropertiesMapper } from './JsonPropertiesMapper'
import { ModelPropertiesMapper } from './ModelPropertiesMapper'

export * from './types'

/**
 * @deprecated Use \@shared/jsona instead.
 */
export default new AppJsona({
  modelPropertiesMapper: new ModelPropertiesMapper(),
  jsonPropertiesMapper: new JsonPropertiesMapper()
})
